"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class OfferModel extends _1.BaseModel {
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            additionalDeposit: 'McLabs2__Additional_Deposit__c',
            closeDate: 'McLabs2__Close_Date__c',
            contractId: 'McLabs2__Escrow__c',
            feasibilityPeriod: 'McLabs2__Feasibility_Period__c',
            financingPeriod: 'McLabs2__Financing_Period__c',
            initialDeposit: 'McLabs2__Initial_Deposit__c',
            independentConsideration: 'McLabs2__Independent__c',
            listingId: 'McLabs2__Listing__c',
            name: 'Name',
            offerDate: 'McLabs2__Offer_Date__c',
            offerPrice: 'McLabs2__Offer_Price__c',
            ownerId: 'OwnerId',
            purchaserId: 'McLabs2__Purchaser__c',
            status: 'McLabs2__Status__c'
        };
    }
}
OfferModel.STATUS = {
    DRAFT: 'Draft',
    PENDING_SELLER_REVIEW: 'Pending seller review',
    COUNTERED: 'Countered',
    ACCEPTED: 'Accepted',
    NOT_ACCEPTED: 'Not accepted'
};
exports.OfferModel = OfferModel;
//# sourceMappingURL=offer.model.js.map